import React, { JSX } from "react";
import {
  InputBaseComponentProps,
  TextField,
  TextFieldProps,
} from "@mui/material";
import { NumericFormat, NumericFormatProps } from "react-number-format";

const NumericFormatCustom = React.forwardRef<
  HTMLInputElement,
  InputBaseComponentProps
>((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...(other as NumericFormatProps)}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange?.({
          target: {
            value: values.value,
          },
        } as React.ChangeEvent<HTMLInputElement>);
      }}
    />
  );
});

NumericFormatCustom.displayName = "NumericFormatCustom";

export type NumericFormatterTextFieldProps = Omit<
  TextFieldProps,
  "defaultValue"
> &
  NumericFormatProps;

function NumericFormatterTextField({
  // NumericFormatProps
  thousandSeparator = true,
  decimalSeparator,
  allowedDecimalSeparators,
  thousandsGroupStyle,
  decimalScale,
  fixedDecimalScale,
  allowNegative,
  allowLeadingZeros,
  suffix,
  prefix,
  defaultValue,
  value,
  valueIsNumericString = true,
  onValueChange,
  isAllowed,
  ...textFieldProps
}: NumericFormatterTextFieldProps): JSX.Element {
  const numericFormatProps: NumericFormatProps = {
    thousandSeparator,
    decimalSeparator,
    allowedDecimalSeparators,
    thousandsGroupStyle,
    decimalScale,
    fixedDecimalScale,
    allowNegative,
    allowLeadingZeros,
    suffix,
    prefix,
    defaultValue,
    value,
    valueIsNumericString,
    onValueChange,
    isAllowed,
  };

  return (
    <TextField
      {...textFieldProps}
      slotProps={{
        ...textFieldProps.slotProps,
        input: {
          inputComponent: NumericFormatCustom,
          // The numeric config occupies the html input's props, so anything a
          // caller sets there is merged in rather than dropped. Attributes like
          // aria-describedby have no other route to the input.
          inputProps: {
            ...numericFormatProps,
            ...textFieldProps.slotProps?.htmlInput,
          } as InputBaseComponentProps,
          ...textFieldProps.slotProps?.input,
        },
      }}
    />
  );
}

export { NumericFormatterTextField };
